import { all } from "redux-saga/effects";
import recoverPassword from "../modules/recoverPassword/saga";
import sessionStorage from "../modules/sessionStorage/saga";
import confirmToken from "../modules/confirmToken/saga";
import billingPlan from "../modules/billingPlan/saga";
import register from "../modules/register/saga";
import qrCode from "../modules/qrCode/saga";
import token from "../modules/token/saga";
import auth from "../modules/auth/saga";
import analytics from "./analytics/saga";
import adjust from "./adjust/saga";
import terms from "./terms/saga";

export default function* rootSaga() {
	return yield all([
		confirmToken,
		billingPlan,
		sessionStorage,
		recoverPassword,
		register,
		qrCode,
		token,
		auth,
		analytics,
		adjust,
		terms,
	]);
}
